var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmsPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sms-phone_svg__clip0_10131_130296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.496 5.694H2.261c-.903 0-1.636.693-1.636 1.547V17.76c0 .854.733 1.547 1.636 1.547h5.235c.903 0 1.636-.693 1.636-1.547V7.24c0-.854-.733-1.547-1.636-1.547zM4.879 17.836c-.544 0-.982-.414-.982-.928 0-.513.438-.928.982-.928.543 0 .981.415.981.928 0 .514-.438.928-.981.928z",
    fill: "url(#sms-phone_svg__paint0_linear_10131_130296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.496 5.694H2.261c-.903 0-1.636.693-1.636 1.547V17.76c0 .854.733 1.547 1.636 1.547h5.235c.903 0 1.636-.693 1.636-1.547V7.24c0-.854-.733-1.547-1.636-1.547zM4.879 17.836c-.544 0-.982-.414-.982-.928 0-.513.438-.928.982-.928.543 0 .981.415.981.928 0 .514-.438.928-.981.928z",
    fill: "url(#sms-phone_svg__paint1_linear_10131_130296)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#sms-phone_svg__filter0_d_10131_130296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.903 0C6.138 0 5 1.138 5 1.903v8.534a.462.462 0 00.633.429l2.144-1.375a.462.462 0 01.172-.033h10.148c.765 0 1.903-1.137 1.903-1.903V1.903C20 1.138 18.863 0 18.097 0H6.903z",
    fill: "#61AF45"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9.483,
    cy: 4.828,
    r: 1.034,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.931,
    cy: 4.828,
    r: 1.034,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.379,
    cy: 4.828,
    r: 1.034,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sms-phone_svg__paint0_linear_10131_130296",
    x1: 9.302,
    y1: 5.819,
    x2: -3.063,
    y2: 13.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sms-phone_svg__paint1_linear_10131_130296",
    x1: 9.113,
    y1: 5.725,
    x2: -3.067,
    y2: 13.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#688FA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sms-phone_svg__clip0_10131_130296"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sms-phone_svg__filter0_d_10131_130296",
    x: 3.036,
    y: -0.982,
    width: 18.929,
    height: 14.828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.982
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.982
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439333 0 0 0 0 0.666667 0 0 0 0 0.15 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10131_130296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10131_130296",
    result: "shape"
  })))));
}

export default __webpack_public_path__ + "./fonts/sms-phone.a347d50fb4c0f2eeb0ebe132940d067d.svg";
export { SvgSmsPhone as ReactComponent };